<template>
  <div class="container">
    <v-expansion-panels>
      <v-expansion-panel isActive="true">
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>

                    <v-row class="my-3" cols="12" align="center" justify="center">
            <v-btn 
                color="success" 
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="getData" 
                :loading="getDataButtonDisabled"
            >
                <v-icon left size="20">mdi-magnify</v-icon>
                <span>ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                color="orange darken-2" 
                dark
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="clearFilters" 
            >
                <v-icon left size="20">mdi-broom</v-icon>
                <span>ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>
          </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση εσόδων..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      :sort-by="['custom_id']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-pagination
      disable-filtering
      hide-default-footer>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Αποτελέσματα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
          <table-export-menu
            title="Έσοδα Epsilon (Κατ. Γ)"
            :headers="headers"
            :items="items"
            :visible="showExport"
            button-class="mb-2"
          />

        </v-toolbar>
      </template>
      
      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>


      <template v-slot:[`item.debit`]="{ item }">
        {{ formatMoney(item.debit) }}
      </template>

      <template v-slot:[`item.credit`]="{ item }">
        {{ formatMoney(item.credit) }}
      </template>

      <template v-slot:[`item.oldBalance`]="{ item }">
        {{ formatMoney(item.oldBalance) }}
      </template>

      <template v-slot:[`item.newBalance`]="{ item }">
        {{ formatMoney(item.newBalance) }}
      </template>


    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      loading: true,
      invoiceStatusValues: [
        { id: -1, name: 'ΑΝΕΞΑΡΤΗΤΑ ΦΠΑ'},
        { id: 0, name: 'ΜΕ ΦΠΑ'},
        { id: 1, name: 'ΧΩΡΙΣ ΦΠΑ'},
      ],

      allerrors : {
        
      },

      dialog: false,

      headers: [
        {
            'value': 'custom_id', 
            'text': 'ID',
            'align': 'left',
        },
        {
            'value': 'EID0S_KINISIS', 
            'text': 'ΕΙΔΟΣ ΚΙΝΗΣΗΣ',
            'align': 'left',
        },
        {
            'value': 'KEPYO', 
            'text': 'ΚΕΠΥΟ',
            'align': 'left',
        },
        {
            'value': 'YPOXREOS_YPOBOLHS', 
            'text': 'ΥΠΟΧΡΕΟΣ ΥΠΟΒΟΛΗΣ',
            'align': 'left',
        },
        {
            'value': 'CODE_SYNAL', 
            'text': 'ΚΩΔ. ΣΥΝΑΛΛΑΣΟΜΕΝΟΥ',
            'align': 'left',
        },
        {
            'value': 'HMEROMHNIA', 
            'text': 'ΗΜΕΡΟΜΗΝΙΑ',
            'align': 'right',
            exportTransformer: (cell) => moment(cell).format("DD/MM/YYYY")
        },
        {
            'value': 'AITIOLOGIA', 
            'text': 'ΑΙΤΙΟΛΟΓΙΑ',
            'align': 'left',
        },
        {
            'value': 'PARASTATIKO', 
            'text': 'ΠΑΡΑΣΤΑΤΙΚΟ',
            'align': 'left',
        },
        {
            'value': 'AKSIA_KEPYO', 
            'text': 'ΑΞΙΑ ΚΕΠΥΟ',
            'align': 'right',
            exportTransformer: (cell) => cell.replace('.', ',')
        },
        {
            'value': 'FPA', 
            'text': 'ΦΠΑ',
            'align': 'right',
            exportTransformer: (cell) => cell.replace('.', ',')
        },
        {
            'value': 'LOGARIASMOS', 
            'text': 'ΛΟΓΑΡΙΑΣΜΟΣ',
            'align': 'left',
        },
        {
            'value': 'XREOSI_PISTOSI', 
            'text': 'ΧΡΕΩΣΗ/ΠΙΣΤΩΣΗ',
            'align': 'left',
        },
        {
            'value': 'AKSIA', 
            'text': 'ΑΞΙΑ',
            'align': 'right',
            exportTransformer: (cell) => cell.replace('.', ',')
        },
        {
            'value': 'PARASTATIKO_ARTHROU', 
            'text': 'ΠΑΡΑΣΤΑΤΙΚΟ ΑΡΘΡΟΥ',
            'align': 'left',
        },
        {
            'value': 'AITIOLOGIA_ARTHROU', 
            'text': 'ΑΙΤΙΟΛΟΓΙΑ ΑΡΘΡΟΥ',
            'align': 'left',
        },
        {
            'value': 'KODIKOS_TAMEIAKIS', 
            'text': 'ΚΩΔΙΚΟΣ ΤΑΜΕΙΑΚΗΣ',
            'align': 'left',
        },
        {
            'value': 'LOIPES_DAPANES', 
            'text': 'ΛΟΙΠΕΣ ΔΑΠΑΝΕΣ',
            'align': 'left',
        },
        {
            'value': 'TAYTOTITA_LIANIKON', 
            'text': 'ΤΑΥΤΟΤΗΤΑ ΛΙΑΝΙΚΩΝ',
            'align': 'left',
        },
        {
            'value': 'AKYROMENO', 
            'text': 'ΑΚΥΡΩΜΕΝΟ',
            'align': 'left',
        },
        {
            'value': 'PEDIO_OMADOPOIHSHS_AKYROSIS', 
            'text': 'ΠΕΔΙΟ ΟΜΑΔΟΠΟΙΗΣΗΣ ΑΚΥΡΩΣΗΣ',
            'align': 'left',
        },


      ],

      items: [],


      documentTypes: [],
      accounts: [],

      selectedAccount: {},

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,

      tradeNameFilterValue: null,
      customerNameFilterValue: null,
      distributorFilterValue: null,
      representativeFilterValue: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      menu2: null,
      menu1: null,

      invoiceStatus: null,


    }),

    watch: {

    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      }
    },

    methods: {

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xlsx')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return amount.toFixed(2)
      },


      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        this.documentIssueDateStopFilter = this.$localDateString(today)

        

        // this.getData();
        this.getFilterValues()
      },

      getFilterValues() {
        // this.accounts = axios.get('/api/accounts')
        //     .then(response => {
        //         this.accounts = response.data
        //     }).catch(error => console.log(error))
      },
      
      getRequestParams() {
        let out = {
          dianomeas: null,
          diakritikos: null,
          eponimia: null,
          invoice_status: -1
        }


        if (this.documentIssueDateStartFilter != null)
          out.issue_date_start = this.documentIssueDateStartFilter

        if (this.documentIssueDateStopFilter != null)
          out.issue_date_stop = this.documentIssueDateStopFilter

        if (this.selectedAccount != null)
            out.customer_id = this.selectedAccount.id

        if (this.tradeNameFilterValue?.length > 0)
          out.diakritikos = this.tradeNameFilterValue

        if (this.customerNameFilterValue?.length > 0)
          out.eponimia = this.customerNameFilterValue


        if (this.distributorFilterValue?.length > 0)
          out.dianomeas = this.distributorFilterValue

        if (this.invoiceStatus != null)
          out.invoice_status = this.invoiceStatus
        
        return out
      },

      getData() {
        this.loading = true;
        this.allerrors = {}

        const params = this.getRequestParams()

        if (params.issue_date_start == null || params.issue_date_stop == null)
          return


        this.getDataButtonDisabled = true;
        axios.post(
            '/api/reports/export-esoda-epsilon-cat-c', 
            {
                params: params
            }
        )
        .then(response => this.items = response.data)
        .finally(() => {
          this.getDataButtonDisabled = false;
          this.loading = false;
        })
        .catch(error => { 
          if (error.response.data)
              this.allerrors = error.response.data.errors
         })
        
      },


      clearFilters() {
        this.documentIssueDateStartFilter = null
        this.documentIssueDateStopFilter = null
      }
    }
  }
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>